var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right_wrapper"},[_c('AddProductHeader'),_c('AddProductForm',{staticClass:"table_wrap no_footer pt-2"})],1),_c('AddKeywordModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }